import {
  withResponsiveOptions,
  withBreakpointObserver,
  getClosestParent,
} from '@studiometa/js-toolkit';
import { MenuBtn, MenuList, Menu as MenuCore } from '@studiometa/ui';

/**
 * @param {*} childInstance
 * @param {*} parentInstance
 * @returns {boolean}
 */
function fixedIsDirectChild(childInstance, parentInstance) {
  return getClosestParent(childInstance, parentInstance.constructor) === parentInstance;
}

/**
 * Menu class.
 */
export default class Menu extends withResponsiveOptions(withBreakpointObserver(MenuCore)) {
  static config = {
    ...MenuCore.config,
    emits: ['open', 'close'],
    options: {
      ...MenuCore.config.options,
      mode: {
        type: String,
        default: 'click',
        responsive: true,
      },
    },
    components: {
      MenuList,
      MenuBtn,
    },
  };

  /**
   * isOpen
   * @returns {boolean}
   */
  get isOpen() {
    return this.menuList?.isOpen ?? false;
  }

  /**
   * onMenuListItemsOpen
   * @param {*} props
   */
  onMenuListItemsOpen(props) {
    if (fixedIsDirectChild(props.target, this)) {
      super.onMenuListItemsOpen(props);
      this.$emit('open');
    }
  }

  /**
   * @param {object} props
   * @param {HTMLElement} props.target
   */
  onMenuListItemsClose({ target }) {
    if (fixedIsDirectChild(target, this)) {
      this.$emit('close');
    }
  }

  /**
   * @param {object} props
   * @param {Event} props.event
   * @param {HTMLElement} props.target
   */
  onMenuBtnClick({ target, event }) {
    if (fixedIsDirectChild(target, this) && this.shouldReactOnClick) {
      event.preventDefault();
      this.toggle();
    }
  }
}
